module.exports = __webpack_public_path__ + "static/odin-abb6442f22cfacb4edd511aaef2460be.mp4";